import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-addfoodsymbol',
  templateUrl: './addfoodsymbol.component.html',
  styleUrls: ['./addfoodsymbol.component.css']
})
export class AddfoodsymbolComponent implements OnInit  {

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;


  //Edit Get Values
  foodsymbolColl: any = [];
 

  countryColl: any = [];
  stateColl: any = [];
  //pageColl:any=[];

  foodsymbolform = new FormGroup({
    foodsymbolid: new FormControl(0),
    foodsymbol: new FormControl('', Validators.required),
    colorcode: new FormControl('', Validators.required),
    isdefault: new FormControl(false),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Foodsymbol";

  @Input() foodsymbolid: number = 0
  @Input() foodsymbol: any = '';
  @Output() emitData = new EventEmitter();

  constructor(private toastr: ToastrService, private appService: DhukanDataService, private route: ActivatedRoute,
    private loginService: LoginDataService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.foodsymbolid = params.id
      }
    });
    this.fnServiceChanges();
  }

  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {

        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }         
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }
    }
    else {
      this.loginService.fnCompanyFaildRedirect();
    }         
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.foodsymbolform.reset();
      this.fnInitializeFoodsymbol();

      if (this.foodsymbolid > 0) {
        this.fngetFoodsymbol();
      }
    
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.foodsymbolid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeFoodsymbol() {
    this.foodsymbolform.setValue({

      foodsymbolid: 0,
      foodsymbol: '',
      colorcode: '',
      isdefault:false,
      inactive:false,
    })
  }
 
  //Get 
  fngetFoodsymbol() {
   
    var data = {
      'foodsymbolid': this.foodsymbolid,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getFoodsymbol(data)
      .subscribe(
        (res) => {
          this.foodsymbolColl = res.json().result;
          var editdata = this.foodsymbolColl[0];
          this.fnEditMode(editdata);
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnSaveBtnClick() {
 
    try {
      if(this.saveloading){
        return;
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.foodsymbolform.valid) {
        //Check
        this.saveloading=true;
        var data = {
          'foodsymbolid': this.foodsymbolid,
          'foodsymbol': this.foodsymbolform.get('foodsymbol').value,
          'colorcode': this.foodsymbolform.get('colorcode').value,
          'isdefault': this.foodsymbolform.get('isdefault').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'inactive': this.foodsymbolform.get('inactive').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }
      
        this.appService.fnCheckFoodsymbol(data).subscribe(
          (res) => {
            //console.log(res)
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.foodsymbolform.get('foodsymbolid').value > 0) {
                //Update Department
                this.fnSetFoodsymbol(data);
              }
              else {
                //Insert Department
                this.fnInsertFoodsymbol(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.saveloading=false;

                this.foodsymbolform.controls['foodsymbol'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.saveloading=false;

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading=false;

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertFoodsymbol(data) {

    this.appService.fnInsertFoodsymbol(data).subscribe(
      (res) => {
        this.saveloading=false;

        if (res.json().status === 200) {

          var result = res.json().result;

          var rtnfoodsymbolid = 0;
          if (result.length > 0) {
            rtnfoodsymbolid = result[0].foodsymbolid
           
          }
          this.toastr.success('', "The new Foodsymbol has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.foodsymbolid);

          this.emitData.emit(rtnfoodsymbolid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading=false;

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetFoodsymbol(data) {

    this.appService.fnSetFoodsymbol(data).subscribe(
      (res) => {
        this.saveloading=false;

        if (res.json().status === 200) {
          this.toastr.success('', "The Foodsymbol has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.foodsymbolid, data.foodsymbol);

          this.emitData.emit(this.foodsymbolid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading=false;

        this.toastr.error('Error', err);
      });

  }



  private fnEditMode(deptBO) {

    this.foodsymbolform.setValue({

      foodsymbolid: deptBO.foodsymbolid,
      foodsymbol: deptBO.foodsymbol,
      colorcode: deptBO.colorcode,
      isdefault: deptBO.isdefault,
      inactive: deptBO.inactive,
    });

    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }



  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),

      }


       this.appService.fnInsertActivity(data).subscribe(
         (res)=>{
         },
         (err)=>{

         });

    } catch {

    }
  }



  public decline() {
    this.activeModal.close(false);
  }



  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
